import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import AdditionalInformation from "../../components/additional-information"
import ContentTransformer from "../../components/Transformers/content-transformer"
import {
  pageEvent,
  pageEventAdditionalInfos,
  evenement,
  eventImg,
  eventDate,
  eventDateFrom,
  eventDateTo,
  eventTaxo,
  eventTitle,
  eventContent,
  eventFooter,
  eventFooterBack,
  eventPlace,
  eventPlaceIcon,
  eventPlaceTitle,
  editButton,
  eventsItemRecurrence,
} from "./styles/detailsEvent.module.scss"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  EventImg,
  EventDate,
  EventTaxo,
  EventTitle,
  EventPlaceIcon,
  EventPlaceTitle,
  EventFooterContainer,
  EventItemRecurrence,
} from "./styled-components/evenement-styled"
import TransitionFade from "../../components/transition-fade"
import FadeIn from "react-fade-in"
import Ariane from "../../components/Ariane/ariane"
import SocialPanel from "../../components/SocialMedias/social-panel"
import EditButton from "../../components/EditButton/edit-button"
import { LightBoxImage } from "../../components/LightBoxImage/light-box-image"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeEvenements(path: { alias: { eq: $slug } }) {
      ...EventItem
    }
  }
`

//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const EvenementTemplate = ({ data, location }) => {
  const nodeEvenement = data.nodeEvenements
  const allTaxos = nodeEvenement.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout isDetail={true}>
      <SEO
        title={nodeEvenement.title}
        description={
          "Dans cette page, vous découvrez l'évènement suivant : " +
          nodeEvenement.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          nodeEvenement.relationships?.field_image_event?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <Ariane
        pageNameLink="/evenements"
        pageName="Tous les évènements"
        isDetail={true}
        postName={nodeEvenement.title}
      />
      <FadeIn delay={150}>
        <section className={pageEvent}>
          <EvenementContent event={nodeEvenement} />
          <EvenementFooter event={nodeEvenement} location={location.href} />
        </section>
        <EvenementInfos event={nodeEvenement} />
      </FadeIn>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const EvenementContent = ({ event }) => {
  return (
    <article className={evenement}>
      <EventImg className={eventImg}>
        {event.relationships?.field_image_event?.localFile && (
          <LightBoxImage
            type={"node"}
            node={{
              alt: event.field_image_event.alt,
              file: event.relationships.field_image_event.localFile,
            }}
          />
        )}
      </EventImg>
      <EventDate className={eventDate}>
        {!event.fields.formatted_field_date_de_fin ? (
          <span className={eventDateFrom}>
            Le {event.fields.formatted_field_date_de_debut}
          </span>
        ) : (
          <>
            <span className={eventDateFrom}>
              Du {event.fields.formatted_field_date_de_debut}
            </span>
            <span className={eventDateTo}>
              {" "}
              au {event.fields.formatted_field_date_de_fin}
            </span>
          </>
        )}
        {event.field_evenement_recurrent && (
          <EventItemRecurrence className={eventsItemRecurrence}>
            Récurrent
          </EventItemRecurrence>
        )}
      </EventDate>
      <EventTaxo className={eventTaxo} role={"list"}>
        {event.relationships.field_taxonomie_thematique && (
          <>
            {event.relationships.field_taxonomie_thematique.map((taxo) => (
              <TransitionFade
                key={taxo.path.alias}
                link={taxo.path.alias}
                role={"listitem"}
              >
                {taxo.name}{" "}
              </TransitionFade>
            ))}
          </>
        )}
      </EventTaxo>
      <EventTitle className={eventTitle}>
        <EditButton
          link={"/node/" + event.drupal_internal__nid + "/edit"}
          addedClass={editButton}
        />
        {event.title}
      </EventTitle>
      <div className={eventContent}>
        {event.body?.processed && (
          <ContentTransformer content={event.body.processed} />
        )}
      </div>
      {event.field_url_lieu && (
        <div className={eventPlace}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={event.field_url_lieu.uri}
          >
            <EventPlaceIcon
              className={eventPlaceIcon}
              size={30}
              icon="location2"
            ></EventPlaceIcon>
            <EventPlaceTitle className={eventPlaceTitle}>
              {event.field_url_lieu.title}
            </EventPlaceTitle>
          </a>
        </div>
      )}
    </article>
  )
}

//-----------------------Child component/Content---------------------------//

//-----------------------Child component/Footer---------------------------//

const EvenementFooter = ({ event, location }) => (
  <EventFooterContainer className={eventFooter}>
    <div className={eventFooterBack}>
      <TransitionFade
        arialabel="Retour à la liste des évènements"
        link="/evenements"
      >
        Retour à la liste des évènements
      </TransitionFade>
    </div>
    <SocialPanel location={location} postData={event} />
  </EventFooterContainer>
)

//-----------------------Child component/Footer---------------------------//

//-----------------------Child component/Infos---------------------------//

const EvenementInfos = ({ event }) => (
  <>
    {event.field_infos_complementaires && (
      <AdditionalInfos className={pageEventAdditionalInfos}>
        <AdditionalInformation node={event} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child component/Infos---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

EvenementTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
EvenementContent.propTypes = {
  event: PropTypes.object.isRequired,
}
EvenementInfos.propTypes = {
  event: PropTypes.object.isRequired,
}
EvenementFooter.propTypes = {
  event: PropTypes.object.isRequired,
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default EvenementTemplate
